module.exports = __webpack_public_path__ + "static/media/CV - Mascaro.dev.3e4458db.pdf";